import React from "react";
import withStyles from "react-jss";
import PropTypes from "prop-types";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import { Header } from "ComponentsUI/Header";
import { PaddingBottom } from "ComponentsUI/Spacings";
import QuestionAnswer from "ComponentsUI/QuestionAnswer";

const styles = theme => ({
    root: {
        position: "static",
    },
    withBackground: {
        position: "relative",
    },
    text: {
        fontFamily: theme.fonts.light,
        fontSize: "16px",
        lineHeight: "1.38",
        color: theme.palette.colors.oneMoreGrey,
        margin: "0 0 0 31px",
    },
    textOffset: {
        margin: 0,
    },
    wrapper: {
        display: "flex",
        flexDirection: "column",
    },
    orderLastText: {
        order: 1000,
    },
    orderLastFaq: {
        order: 1001,
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        text: {
            fontSize: "14px",
            lineHeight: "1.29",
            margin: "0 0 0 21px",
        },
        textOffset: {
            margin: 0
        }
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        text: {
            fontSize: "14px",
            lineHeight: "1.29",
            margin: "0",
        },
    },
});

const SeoText = ({
    classes,
    children,
    background,
    text,
    title,
    faq,
    stockText,
    baseOffset,
    withoutMarginTopSeoText,
}) => {
    return (
        <div className={classes.wrapper}>
            {text && (
                <div className={classes.orderLastText}>
                    <PaddingBottom>
                        <div
                            className={classNames(classes.root, {
                                [classes.withBackground]: !!background,
                            })}
                        >
                            {background}
                            <Container>
                                {!!title && (
                                    <Header h2Tag={true}>{title}</Header>
                                )}
                                {typeof text == "string" ? (
                                    <div
                                        className={classNames(classes.text, {
                                            [classes.textOffset]: baseOffset
                                        })}
                                        dangerouslySetInnerHTML={{
                                            __html: text,
                                        }}
                                    />
                                ) : (
                                    <div className={classNames(classes.text, {
                                        [classes.textOffset]: baseOffset
                                    })}>{text}</div>
                                )}
                            </Container>
                        </div>
                    </PaddingBottom>
                </div>
            )}
            {!!faq?.length && (
                <div className={classes.orderLastFaq}>
                    <PaddingBottom>
                        <div className={classes.root}>
                            <Container>
                                <Header h2Tag={true}>
                                    {stockText.FREQUENT_QUESTION}
                                </Header>
                                <QuestionAnswer faq={faq} />
                            </Container>
                        </div>
                    </PaddingBottom>
                </div>
            )}

            {children}
        </div>
    );
};

SeoText.defaultProps = {
    background: null,
    text: "",
    title: "",
};

SeoText.propTypes = {
    background: function(props, propName, componentName) {
        if (props[propName] !== null) {
            if (
                !props[propName].type ||
                !props[propName].type.displayName ||
                props[propName].type.displayName != "Jss(Background)"
            ) {
                return new Error(
                    `Invalid prop ${propName}, value must be Jss(Background) component. Validation failed.`
                );
            }
        }
    },
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    title: PropTypes.string,
};

export default withStyles(styles)(SeoText);
